export default __webpack_public_path__ + "static/media/Mensaje_bienvenida_mundo_4.f8872225.png";